module.exports = __webpack_public_path__ + "media/failed.1f4cd5b1.wav";